var app = app || angular.module('harriApp');

app.controller('IframeController', ['$scope', '$stateParams', 'iframeUrl', '$sce',
    function ($scope, $stateParams, iframeUrl, $sce) {

        $scope.url = $sce.trustAsResourceUrl(iframeUrl);

        if ($stateParams.iframeUrl && $stateParams.iframeUrl.toLowerCase() == 'tts-li') {
            // To be used in harri.auth.social.js after a successful LinkedIn login
            HStorageManager.put({
                key: 'tts_li_utms',
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                value: {
                    utm_campaign: $stateParams.utm_campaign,
                    utm_content: $stateParams.utm_content,
                    utm_medium: $stateParams.utm_medium,
                    utm_source: $stateParams.utm_source,
                    utm_term: $stateParams.utm_term
                }
            });
        }

    }]);
